export default {
  zh: {
    def: `AAAAA赠送了CP礼物给你，你是否同意和他成为CP`,
    btYes: `同意`,
    btNo: `拒绝`,
    isYes: `你们已经是CP`,
    isNo: `您已经拒绝`,
    days: 'days',
  },
  en: {
    def: `AAAAA gave you a CP gift, do you agree to become CP with him?`,
    btYes: `agree`,
    btNo: `reject`,
    isYes: `You are already CP`,
    isNo: `you have declined`,
    days: 'days',
  },
  ar: {
    def: `لقد منحك AAAAA هدية CP.  هل توافق على أن تنضم الى CP معه`,
    btYes: `موافق`,
    btNo: `رفض `,
    isYes: `أنت بالفعل ضمن CP`,
    isNo: `تم الرفض`,
    days: 'أيام',
  },
  tr: {
    def: `AAAAA size bir CP hediyesi verdi, onunla CP olmayı kabul ediyor musunuz?`,
    btYes: `kabul etmek`,
    btNo: `reddetmek`,
    isYes: `Sen zaten CP'sin`,
    isNo: `reddettin`,
    days: 'gün',
  },
  pt:{
    "def": "AAAAA te deu um presente de CP, você concorda em se tornar CP com ele?",
    "btYes": "concordo",
    "btNo": "rejeitar",
    "isYes": "Você já é CP",
    "isNo": "Você rejeitou",
    "days": "dias"
},
    id:{
    "def": "AAAAA memberimu hadiah CP, apakah kamu setuju untuk menjadi CP dengannya?",
    "btYes": "setuju",
    "btNo": "tolak",
    "isYes": "Kamu sudah menjadi CP",
    "isNo": "kamu sudah menolak",
    "days": "hari"
},
    uz:{
    "def": "AAAAA sizga CP sovg'asini berdi, unga CP bo'lishga rozi bo'lasizmi?",
    "btYes": "rozi",
    "btNo": "rad etish",
    "isYes": "Siz allaqachon CP bo'lsangiz",
    "isNo": "siz rad ettiz",
    "days": "kunlar"
},
    ru:{
    "def": "AAAAA дал вам подарок CP, согласны ли вы стать CP с ним?",
    "btYes": "согласен",
    "btNo": "отклонить",
    "isYes": "Вы уже CP",
    "isNo": "вы отклонили",
    "days": "дней"
},
    fa:{
    "def": "AAAAA به شما هدیه CP داده است، آیا موافقید که با او CP شوید؟",
    "btYes": "موافقم",
    "btNo": "رد می‌کنم",
    "isYes": "شما قبلاً CP هستید",
    "isNo": "شما رد کرده‌اید",
    "days": "روز"
}


}


// WEBPACK FOOTER //
// src/pages/activity/cp-yes/lang.js